export default "__VITE_ASSET__CfATxLS2__"